/**
 * Framework-agnostic generic Coral response, allowing individual operations
 * to return properly-typed response bodies.
 */
export class CoralResponse {
    constructor(init) {
        this.body = init.body || null;
        this.headers = init.headers || [];
        this.status = init.status;
        this.statusText = init.statusText;
        this.url = init.url || null;
        this.ok = init.ok;
    }
}
